import React, { createContext, useContext, useState } from "react";

type LiveContextType = {
  anyLive: boolean;
  setAnyLive: React.Dispatch<React.SetStateAction<boolean>>;
};

const LiveContext = createContext<LiveContextType | undefined>(undefined);

export const useLiveContext = () => {
  const ctx = useContext(LiveContext);
  if (!ctx) throw new Error("useLiveContext must be used within LiveProvider");
  return ctx;
};

export const LiveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [anyLive, setAnyLive] = useState(false);
  return (
    <LiveContext.Provider value={{ anyLive, setAnyLive }}>
      {children}
    </LiveContext.Provider>
  );
};
